export default "__VITE_ASSET__DqQTM_Cv__"